export default __webpack_public_path__ + "static/media/KK_master.4c6bc1f9.jpg";